import { render } from "preact";
import "./index.css";
import { App } from "./app.tsx";

render(<App />, document.getElementById("app")!);
